import { gql } from '../../../__generated__/gql';

export const GET_EMAILS = gql(`
  query getDashboardSupportedNotifications($where: DashboardSupportedNotificationsWhereInput!) {
    getDashboardSupportedNotifications(where: $where) {
      notifications
    }
  }
`);
